<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,7.990000009536743C16,7.990000009536743,0,1.9900000095367432,0,1.9900000095367432C0,1.9900000095367432,4,7.990000009536743,4,7.990000009536743C4,7.990000009536743,0,13.990000009536743,0,13.990000009536743C0,13.990000009536743,16,7.990000009536743,16,7.990000009536743C16,7.990000009536743,16,7.990000009536743,16,7.990000009536743Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DirectionRight',
} as DefineComponent
</script>
